var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.556 0H10.444C7.67408 0 5.01761 1.10035 3.05898 3.05898C1.10035 5.01761 4.78531e-08 7.67408 4.78531e-08 10.444V29.556C-0.000131249 30.9276 0.269921 32.2857 0.794735 33.5529C1.31955 34.8201 2.08884 35.9715 3.05868 36.9413C4.02852 37.9112 5.17991 38.6805 6.4471 39.2053C7.71428 39.7301 9.07244 40.0001 10.444 40H29.556C30.9276 40.0001 32.2857 39.7301 33.5529 39.2053C34.8201 38.6805 35.9715 37.9112 36.9413 36.9413C37.9112 35.9715 38.6805 34.8201 39.2053 33.5529C39.7301 32.2857 40.0001 30.9276 40 29.556V10.444C40 7.67408 38.8997 5.01761 36.941 3.05898C34.9824 1.10035 32.3259 0 29.556 0ZM14.7031 8.45312H10.6719V31.5625H14.7031V8.45312ZM16.8906 20L25.7344 31.5469H30.7813L22.0781 20L30.7813 8.45312H25.7344L16.8906 20Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKava);
export default __webpack_public_path__ + "static/media/kava.58829a04a0397e0a1c787e1294dd9ad7.svg";
export { ForwardRef as ReactComponent };